import { ReactNode } from 'react';
import { BrowserRouter } from 'react-router-dom';

import { RenderingClientLocationHooks } from './RenderingClientLocationHooks';

type Props = {
  children: ReactNode;
};

export function RenderingClientInnerWrapper({ children }: Props) {
  return (
    <BrowserRouter>
      {children}
      <RenderingClientLocationHooks />
    </BrowserRouter>
  );
}
